module.exports = __webpack_public_path__ + "img/european-union.ad8fc272.svg";